import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'blue' | 'gray' | 'white' | 'green';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

const colorClasses = {
  blue: 'border-blue-600',
  gray: 'border-gray-600',
  white: 'border-white',
  green: 'border-green-600',
};

export function Spinner({ 
  size = 'md', 
  color = 'blue',
  className = '' 
}: SpinnerProps) {
  return (
    <div 
      className={`
        animate-spin 
        rounded-full 
        border-2 
        border-t-transparent 
        ${sizeClasses[size]} 
        ${colorClasses[color]}
        ${className}
      `}
    />
  );
};

// Full screen spinner with optional text
interface FullScreenSpinnerProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: 'blue' | 'gray' | 'white' | 'green';
}

export function FullScreenSpinner({ 
  text = 'Loading...',
  size = 'lg',
  color = 'blue'
}: FullScreenSpinnerProps) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <Spinner size={size} color={color} className="mx-auto mb-4" />
        {text && (
          <p className="text-gray-600">{text}</p>
        )}
      </div>
    </div>
  );
}; 